import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIsLoggedIn } from "@dynamic-labs/sdk-react-core";
import { UserPreferenceEnum } from "@dripit/types";

import { RootState, profileActions } from "@/store";
import { OnboardingDialog } from "./OnboardingDialog";
import { OnboardingDrawer } from "./OnboardingDrawer";
import { useBreakpoints } from "@/hooks";
import { useUpdateUserPreference } from "@/api/userQueries";

export const OnBoarding: React.FC = () => {
  const isLoggedIn = useIsLoggedIn();
  const dispatch = useDispatch();
  const { isGreaterThan } = useBreakpoints();
  const { showOnboarding, fromQuickTour } = useSelector(
    (state: RootState) => state.profile
  );
  const [open, setOpen] = React.useState(false);
  const [step, setStep] = React.useState(0);
  const updatePreferenceMutation = useUpdateUserPreference();

  React.useEffect(() => {
    if (isLoggedIn && showOnboarding) {
      setOpen(true);
      dispatch(profileActions.setShowOnboarding(false));
    }
  }, [isLoggedIn, showOnboarding, dispatch]);

  const handleClose = () => {
    setOpen(false);
    dispatch(
      profileActions.setShowOnboarding({ open: false, fromQuickTour: false })
    );
  };

  const handleCompleteOnboarding = async () => {
    if (fromQuickTour) {
      handleClose();
      return;
    }
    try {
      await updatePreferenceMutation.mutateAsync({
        key: UserPreferenceEnum.isWelcomeWizardCompleted,
        value: "true",
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {isGreaterThan("lg") ? (
        <OnboardingDialog
          open={open}
          step={step}
          onComplete={handleCompleteOnboarding}
          setOpen={setOpen}
          setStep={setStep}
          onClose={fromQuickTour ? handleClose : undefined}
        />
      ) : (
        <OnboardingDrawer
          open={open}
          step={step}
          onComplete={handleCompleteOnboarding}
          setOpen={setOpen}
          setStep={setStep}
          onClose={fromQuickTour ? handleClose : undefined}
        />
      )}
    </>
  );
};
